import React from 'react';
import classes from './Form.css';
import Button from '../UI/button/button';


const Form=(props)=>{
	return (
		<React.Fragment>
			<h3 className={classes.Header}>Enter Your Details</h3>
			<form className={classes.Form}>

					<label>Name</label>
						<input type="text" placeholder="name" onChange={props.nameHandler}/>
						
						<label>Address</label>
						<input type="text" placeholder="street" onChange={props.nameHandler}/>
						<input type="text" placeholder="zipcode" onChange={props.nameHandler} maxLength={10} minLength={6}/>
						
						<label>Email</label>
						<input type="email" placeholder="email" onChange={props.nameHandler} required/>
						
						<label>Delivery Method</label>
						<select onChange={props.delivery}>
						<option default>Standard</option>
						<option>Flash</option>
					</select>

				<Button click={props.submitHandler} btnType="Grey">Submit</Button>
			</form>
		</React.Fragment>

		)
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/Form.jsx